module.exports = __webpack_public_path__ + "img/arrow-light-up.2e5eb6d3.svg";